import { render, staticRenderFns } from "./Formulario_cotizacion.vue?vue&type=template&id=2efe29ff&lang=pug&"
import script from "./Formulario_cotizacion.vue?vue&type=script&lang=js&"
export * from "./Formulario_cotizacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports